export default "__VITE_ASSET__0f57cce2__"